import firebase from 'firebase'
import 'firebase/firestore'

var firebaseConfig = {
      apiKey: "AIzaSyD-oBoFbNY4Bl5o_DEmqyaSbYzVGx-coyw",
      authDomain: "elisabot-8e560.firebaseapp.com",
      databaseURL: "https://elisabot-8e560.firebaseio.com",
      projectId: "elisabot-8e560",
      storageBucket: "elisabot-8e560.appspot.com",
      messagingSenderId: "836181843562",
      appId: "1:836181843562:web:3b787d30327900e1027413"
    };
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);

const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser
const users = db.collection('users')
const baustellen = db.collection('baustellen')
const archiv = db.collection('archiv')
const angebote = db.collection('angebote')

export {
    db,
    auth,
    currentUser,
    users,
    baustellen,
    archiv,
    angebote
}